module.exports = __webpack_public_path__ + "0682d932cbe6a4a1757c9d3fa3b23a1f.png";